import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const defaultFeature = {
  name: "",
  description: "",
};

export default function FeatureSelectorDialog({
  open,
  onClose,
  onSubmit,
  options = [],
  isLoading = false,
}) {
  const { t } = useTranslation();
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [customFeature, setCustomFeature] = useState(defaultFeature);

  useEffect(() => {
    if (!open) {
      setSelectedFeature(null);
      setCustomFeature(defaultFeature);
    }
  }, [open]);

  const handleSubmit = () => {
    if (selectedFeature) {
      onSubmit({
        mode: "existing",
        feature: selectedFeature,
      });
      return;
    }
    const trimmedName = customFeature.name.trim();
    if (!trimmedName) {
      return;
    }
    onSubmit({
      mode: "new",
      feature: {
        name: trimmedName,
        description: customFeature.description.trim(),
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {t("manufacturing.addFeature", "Add feature")}
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Autocomplete
            options={options}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) =>
              option?.name
                ? option.description
                  ? `${option.name} \u2013 ${option.description}`
                  : option.name
                : ""
            }
            value={selectedFeature}
            onChange={(_, value) => setSelectedFeature(value || null)}
            loading={isLoading}
            clearOnEscape
            renderInput={(params) => (
              <TextField
                {...params}
                label={t(
                  "manufacturing.selectExistingFeature",
                  "Search existing feature"
                )}
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label={t("manufacturing.featureName", "Feature name")}
              variant="outlined"
              fullWidth
            value={customFeature.name}
            onChange={(e) =>
              setCustomFeature({
                ...customFeature,
                name: e.target.value,
              })
            }
            disabled={Boolean(selectedFeature)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
            <TextField
              label={t("manufacturing.featureDescription", "Feature description")}
              variant="outlined"
              fullWidth
            value={customFeature.description}
            onChange={(e) =>
              setCustomFeature({
                ...customFeature,
                description: e.target.value,
              })
            }
            disabled={Boolean(selectedFeature)}
          />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t("common.cancel", "Cancel")}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={!selectedFeature && !customFeature.name.trim()}
        >
          {selectedFeature
            ? t("manufacturing.addExistingFeature", "Add existing feature")
            : t("manufacturing.addNewFeature", "Add new feature")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
